import React, { useState } from 'react';
import styled from 'styled-components';
import LecturerSidebar from './LecturerSidebar';
import LecturerTopBar from './LecturerTopBar';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f9fafb;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  transition: margin-left 0.3s ease;
  margin-left: ${(p) => (p.$sidebarOpen ? '256px' : '80px')};
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f9fafb;
  padding: 24px;
`;

export default function LecturerLayout({ children, title }) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <Root>
      <LecturerSidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
      <Main $sidebarOpen={sidebarOpen}>
        <LecturerTopBar title={title} onMenuClick={() => setSidebarOpen(!sidebarOpen)} sidebarOpen={sidebarOpen} />
        <Content>{children}</Content>
      </Main>
    </Root>
  );
}
